export default "/img/KN.51869be2db6b4bb8e761e1e45c1ebcc1.png";